import React, { useContext, useEffect, useRef, useState } from "react";
import { useSpring, animated } from "react-spring";

import { useScreenTransition } from "../../Hooks/useScreenTransition";

import "react-datepicker/dist/react-datepicker.css";
import { DataContext } from "../../Context/DataContext";
import { NotificationContext } from "../../Context/NotificationContext";
import { TransitionContext } from "../../Context/TransitionContext";
import TopBar from "../../Components/TopBar";
import { usePayPalScriptReducer, PayPalButtons } from "@paypal/react-paypal-js";
import { useParams } from "react-router-dom";
import { v4 as uuidv4 } from "uuid";
import { AuthContext } from "../../Context/AuthContext";
import axios from "axios";
import AccountNavBar from "../../NewComponents/AccountNavBar";
import Billing from "./Setting/Billing";
import OrderSummary from "../Order/components/OrderSummary";
import SecureAndPrivate from "../../NewComponents/SecureAndPrivate";
import CARDICON from "../../assets/icons/CardBlue.png";
import PAYPAL from "../../assets/icons/paypal.png";
import { ReactComponent as BANK } from "../../assets/icons/bank.svg";
import { ReactComponent as CHECK } from "../../assets/icons/Bank_Check.svg";
import { ReactComponent as DOWNLOAD } from "../../assets/icons/Download.svg";
import { ReactComponent as STRIPEICON } from "../../assets/icons/stripe.svg";
import SendPaymentLinkPopUp from "../../NewComponents/SendPaymentLinkPopUp";
import {
  CardNumberElement,
} from "@stripe/react-stripe-js";
import PopUpModal from "../../NewComponents/PopUpModal";
import { ReactComponent as ORDERSUCCESS } from "../../assets/icons/order-success.svg";
import { ReactComponent as QUOTESUCCESS } from "../../assets/icons/quote-success.svg";
import { ReactComponent as PAYPALICON } from "../../assets/icons/paypal_logo.svg";
import { decrTeamFreeExpedOrder, formatTotal, getClientSecret, getDiscount, getShortOrderNo, getTeamOwnerEmail, getTotal } from "../../Data/Functions";

import "./MakePayment.css";
import BankTransfer from "./Payments/bankTransfer";
import CheckTransfer from "./Payments/checkTransfer";
import { InvoiceToPrint } from "../../Components/InvoicePrint";
import { firestore, getFullHttpUrl } from "../../firebase.config";
import NewButton from "../../NewComponents/NewButton";
import { MultiInvoicePrint } from "../../Components/MultiInvoicePrint";
import { getCounter } from "../../Data/Functions/getCounter";
import StripeExpressCheckout from "../../NewComponents/StripeExpressCheckout";
import { SingleInvoicePrint } from "../../Components/SingleInvoicePrint";
import { QuoteSummaryToPrint } from "../../Components/QuoteSummaryToPrint";
import ElementsWrapper from "../../NewComponents/ElementsWrapper";
import OpenInvoiceModal from "../../NewComponents/OpenInvoiceModal";
import { ChevronDown, ChevronUp } from "react-feather";
import { FormTextInput } from "../../Components/FormTextInput";

const MakePayment = ({ windowSize }) => {
  const { transitionTo } = useScreenTransition();
  const { userLoaded, userData, teamData, order, setOrder } = useContext(DataContext);
  const { showNotification } = useContext(NotificationContext);
  const { signedIn } = useContext(AuthContext);
  const { setColor } = useContext(TransitionContext);

  const stripeRef = useRef(null);
  const [customerId, setCustomerId] = useState("");

  const [isLoading, setIsLoading] = useState(false);
  // const [isOrderLoading, setIsOrderLoading] = useState(false);
  const [orderSubmitButton, setOrderSubmitButton] = useState("Pay");
  const [transferFiles, setTransferFiles] = useState([]);
  const [checkFiles, setCheckFiles] = useState([]);
  const [isOrderSummaryOpen, setIsOrderSummaryOpen] = useState(false);

  const statusOverlayProps = useSpring({
    display: isLoading ? "flex" : "none",
  });

  const [showSuccessModal, setShowSuccessModal] = useState(false);

  const [showSendPayment, setShowSendPayment] = useState(false);
  const [paymentCardId, setPaymentCardId] = useState("");

  const [cardsList, setCardsList] = useState([]);

  const [selectedPaymentType, setSelectedPaymentType] = useState("all");

  const [invoice, setInvoice] = useState();

  const [cardName, setCardName] = useState("");
  const [saveCard, setSaveCard] = useState(false);
  const [orders, setOrders] = useState([]);
  const [downloadInvoice, setDownloadInvoice] = useState("");
  const [discount, setDiscount] = useState(0);
  const [openInvoiceModal, setOpenInvoiceModal] = useState("");
  const [discountCode, setDiscountCode] = useState("");

  const handleStripeReady = ({stripe, elements}) => {
    stripeRef.current = {stripe, elements};
  }

  useEffect(() => {
    setColor(true);
  }, [setColor]);

  const { itemID, item } = useParams();

  useEffect(
    (e) => {
      setIsLoading(true);
      try{
      if (
        item &&
        itemID &&
        (item === "order" ||
          item === "orderInvoice" ||
          item === "quote" ||
          item === "invoice")
      ) {
        firestore
          .collection(
            checkItemType("orders", "quotes", "orderInvoices", "orders")
          )
          .doc(itemID)
          .get()
          .then((itemDoc) => {
            if (itemDoc.exists) {
              const itemData = itemDoc.data();
              if (item === "quote" ) 
              {
                if(itemData.status === "ordered" && itemData.orderId){
                  transitionTo(`/account/order/${itemData.orderId}`, e);
                }else if((itemData.status !== "replied" || itemData.status === "cancelled")){
                  transitionTo("/", e);
                }
              } else if (
                item === "order" &&
                (itemData.status === "cancelled" ||
                  (itemData.paypalOrderID &&
                    itemData.paypalOrderID !== "pay-later"))
              ) { 
                transitionTo("/", e);
              } else if (item === "order" && (itemData.orderInvoiceId)
              ) {
                transitionTo(`/make-payment/invoice/${itemData.orderInvoiceId}`, e);
              } else if(item === "invoice" && itemData.status !== "pay-later" && itemData.status !== "overdue") {
                transitionTo("/", e);
              }
              setInvoice({ ...itemData, id: itemDoc.id });
            } else {
              transitionTo("/", e);
            }

          })
          .catch((error) => {
            console.log(error)
            showNotification(
              "Error",
              "An error ocurred. Please, try again. If it persists, contact Support.",
              "error"
            );
          });
      } else {
        transitionTo("/", e);
      }
    }catch(error){
      console.log(error);
      showNotification(
        "Error",
        "An error ocurred. Please, try again. If it persists, contact Support.",
        "error"
      );
    }finally{
      setIsLoading(false)
    }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [item, itemID]
  );

  useEffect(() => {
    if(invoice && invoice.discount){
      setDiscount(invoice.discount)
    }
  }, [invoice])

    useEffect(() => { 
      if(item === "invoice" && itemID){
  
        let query = firestore.collection("orders").where("orderInvoiceId", "==", itemID)
        
        query.orderBy("timestamp" ,"desc" )
        .get().then((qSnap) => {
  
          if(qSnap.empty){
            return;
          }
  
          const ordersData = qSnap.docs.map(doc => ({...doc.data(), id: doc.id}));
          setOrders(ordersData);
        }).catch((error) => {
          console.log(error);
          showNotification(
            "Error",
            "An error ocurred while loading the orders. Please, try again. If it persists, contact Support.",
            "error"
          );
        });
      }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [invoice, item, itemID]);

  useEffect(() => {
    if (signedIn && userData) {
      if (userData.teamId && teamData) {
        setCardsList(teamData.paymentMethods ? teamData.paymentMethods : []);
      } else {
        setCardsList(userData.paymentMethods ? userData.paymentMethods : []);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userData, teamData]);


  const createOrder = async (data, actions) => {
    try {
      // Retrieve total and discount
      const total = item === "invoice" ? invoice.totalPrice : getTotal(invoice) - getDiscount(invoice);
      const discount = "invoice" ? 0 : getDiscount(invoice);

      // Validate total and discount
      if (typeof total !== 'number' || isNaN(total)) {
        console.error("Error: Invalid total amount.", total);
        showNotification("Error", "Unable to calculate the total amount. Please try again later.", "error");
        return Promise.reject("Invalid total amount.");
      }

      if (typeof discount !== 'number' || isNaN(discount)) {
        console.error("Error: Invalid discount amount.", discount);
        showNotification("Error", "Unable to calculate the discount. Please try again later.", "error");
        return Promise.reject("Invalid discount amount.");
      }


      // Calculate final amount and validate it
      const finalAmount = (total - discount).toFixed(2);

      if (isNaN(finalAmount) || parseFloat(finalAmount) <= 0) {
        console.error("Error: Invalid final amount for PayPal transaction.", finalAmount);
        showNotification("Error", "The amount to be paid is not valid. Please check your order details.", "error");
        return Promise.reject("Invalid final amount.");
      }

      // Create PayPal order
      return actions.order.create({
        intent: "CAPTURE",
        purchase_units: [
          {
            description: "Your Order",
            amount: {
              currency_code: "USD",
              value: finalAmount,
            },
            reference_id: String(invoice.id || "default-reference-id")
          }
        ],
        application_context: {
          brand_name: "eVerbary",
          landing_page: "NO_PREFERENCE",
          user_action: "PAY_NOW",
          payment_method: {
            payee_preferred: "IMMEDIATE_PAYMENT_REQUIRED",
          }
        }
      })
    } catch (error) {
      console.error("Error creating PayPal order:", error);
      showNotification("Error", "An error occurred while creating the PayPal order. Please try again.", "error");
      return Promise.reject(error);
    }
  };

  const onOrderApprove = async(data, actions) => {
    await actions.order.capture().then((details) => {
      setIsLoading(true);
      if (item === "order") {
        handleOrderUpdate(data.orderID);
      } else if (item === "quote") {
        handlePlaceOrder(invoice, data.orderID);
      } else if (item === "invoice") {
        handleInvoiceUpdate(data.orderID);
      }
    });
  };

  const onAfterOrderApprove = async(billingToken) => {
    const total = item === "invoice" ? invoice.totalPrice : getTotal(invoice);
      const discount = "invoice" ? 0 : getDiscount(invoice);
      const finalAmount = (total - discount).toFixed(2);

      if (isNaN(finalAmount) || parseFloat(finalAmount) <= 0) {
        console.error("Error: Invalid final amount for PayPal transaction.", finalAmount);
        showNotification("Error", "The amount to be paid is not valid. Please check your order details.", "error");
        return Promise.reject("Invalid final amount.");
      }

    await axios.post(getFullHttpUrl("paypal-chargeCustomerWithVault"), {amount: finalAmount, billingToken}).then((res) => {
      console.log("charged", finalAmount, res.data)
      alert("charged")
      // setIsLoading(true);
      // if (item === "order") {
      //   handleOrderUpdate(data.orderID);
      // } else if (item === "quote") {
      //   handlePlaceOrder(invoice, data.orderID);
      // } else if (item === "invoice") {
      //   handleInvoiceUpdate(data.orderID);
      // }
    });
  };

  const onOrderPaymentFailure = (data, actions) => {
    setIsLoading(false)
    showNotification(
      "Error",
      "An error ocurred while paying the payment. Please, try again.",
      "error"
    );
  };


  const handleInvoiceUpdate = async (paymentID, status = "paid", files) => {

    setOrderSubmitButton("Paying...");
    setIsLoading(true);

    let updateData = {
        paymentId: paymentID,
        status: status,
      }

    if(status === "on-hold" && files){
      updateData ={
        files: files,
        paymentId: selectedPaymentType,
        status: status
      }
    }

    await firestore
      .collection("orderInvoices")
      .doc(invoice.id)
      .update(updateData)
      .then(() => {
        setOrderSubmitButton("Pay");
        setShowSuccessModal(true);
        // setIsLoading(false);
      })
      .catch((error) => {
        setOrderSubmitButton("Pay");
        setIsLoading(false);
        showNotification(
          "Error",
          "An error ocurred while finishing the order. Please, try again.",
          "error"
        );
      });
  };

  const handleOrderUpdate = async (paymentID) => {

    setOrderSubmitButton("Paying...");
    setIsLoading(true);

    let updateData = {};

    if (invoice.status === "created") {
      updateData = {
        paypalOrderID: paymentID,
        status: "new",
        
      };

    } else {
      updateData = {
        paypalOrderID: paymentID,
      };
    }

    await firestore
      .collection("orders")
      .doc(invoice.id)
      .update(updateData)
      .then(() => {
        setOrderSubmitButton("Pay");
        setShowSuccessModal(true);
        // setIsLoading(false);
        if(order.expedited || order.expeditedPlus){
          decrTeamFreeExpedOrder(order.teamId);
        }

        if (invoice.status === "created") {
          if(order.orderNumber === invoice.orderNumber){
            localStorage.setItem(
              "order",
              JSON.stringify({ orderID: "", name: "", email: "", parsed: true })
            );
            setOrder({ orderID: "", name: "", email: "", parsed: true });
          }
        } 
      })
      .catch((error) => {
        setOrderSubmitButton("Pay");
        setIsLoading(false);
        showNotification(
          "Error",
          "An error ocurred while finishing the order. Please, try again.",
          "error"
        );
      });
  };

  const getCustomerId = async (id, isTeam) => {
    const email = isTeam && userData ? await getTeamOwnerEmail(userData.teamId) : null;
    await axios({
      method: "post",
      url: getFullHttpUrl("stripe-createCustomer"),
      data: {
        name: userData ? (userData.teamId && teamData ? teamData.name : userData.name) : invoice.name || "guest",
        email: email ? email : userData ? userData.email : invoice.email || "guest@guest.com",
      },
    })
      .then((res) => {
        if (res.data && res.data.customerId) {
          if (id) {
            if (isTeam) {
              firestore.collection("teams").doc(id).update({
                stripeCustomerId: res.data.customerId,
              });
            } else {
              firestore.collection("users").doc(id).update({
                stripeCustomerId: res.data.customerId,
              });
            }
          }
          setCustomerId(res.data.customerId);
        } else {
          setCustomerId("");
        }
      })
      .catch((e) => {
        showNotification(
          "Error",
          "There was an error. Please, try again or refresh the page.",
          "error"
        );
      });
  };

  useEffect(() => {
    if(customerId !== ""){
      return;
    }
    if (signedIn && userData) {
      if (userData.teamId && teamData) {
        if (teamData.stripeCustomerId) {
          setCustomerId(teamData.stripeCustomerId);
        } else {
          getCustomerId(userData.teamId, true);
        }
      } else {
        if (userData.stripeCustomerId) {
          setCustomerId(userData.stripeCustomerId);
        } else {
          getCustomerId(userData.id, false);
        }
      }
    } else {
      setCustomerId("");
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userData, teamData, userLoaded]);

const handleSaveCard = async (result) => {
    console.log(result)
    // status: "requires_action"
    // processing: null
    // cancelled at
    // last_payment_error

    if (result.error) {
      console.log("error",result.error)
      showNotification("Error", result.error.message, "error");
      setOrderSubmitButton("Pay");
      setIsLoading(false);
      return;
    } else if(result.paymentIntent){
      const { payment_method: paymentMethodId, id, last_payment_error, status } = result.paymentIntent;

      if (last_payment_error) {
        console.log("error",last_payment_error.message)
        showNotification("Error", last_payment_error.message, "error");
        setOrderSubmitButton("Pay");
        setIsLoading(false);
        return;
      } 

      if (saveCard && paymentCardId === "") {
        if (customerId) {
          await axios({
            method: "post",
            url: getFullHttpUrl("stripe-attachPaymentMethodToCustomer"),
            data: {
              customerId: customerId,
              paymentMethodId: paymentMethodId,
            },
          }).then((res) => {
            
            const defaultCard = cardsList.length === 0 ? true : false;
            const methodDetails = res.data.paymentMethod;

            firestore
              .collection(userData.teamId ? "teams" : "users")
              .doc(userData.teamId ? userData.teamId : userData.id)
              .update({
                paymentMethods: [
                  ...cardsList,
                  {
                    default: defaultCard,
                    card: methodDetails.card,
                    id: methodDetails.id,
                    billing_details: methodDetails.billing_details,
                    customer: methodDetails.customer
                  },
                ],
              });
          });
        }
      }
      if(status === "succeeded"){
        if (item === "order") {
            handleOrderUpdate(id);
          } else if (item === "quote") {
            handlePlaceOrder(invoice, id);
          } else if(item === "invoice") {
            handleInvoiceUpdate(id)
          }
      }else{
        setOrderSubmitButton("Pay");
        setIsLoading(false);
        return;
      }
    }

  }

  const handleCardSubmit = async (e) => {
      e.preventDefault();

  
      if (selectedPaymentType === "pay-later") {
        handleOrderUpdate(invoice, "pay-later");
        return;
      }
  
      setOrderSubmitButton("Paying...");
      const {stripe, elements} = stripeRef.current || {};
      if (!stripe || !elements) {
        showNotification(
          "Error",
          "There was an error. Please, try again or refresh the page.",
          "error"
        );
        return;
      }
  
      setIsLoading(true);
  
      const cardEelment = elements.getElement(CardNumberElement);
      const amount = item === "invoice" ? invoice.totalPrice : (getTotal(invoice) - getDiscount(invoice));
  
      try {
        if(selectedPaymentType === "card"){
          const number = item === "invoice" ? invoice.invoiceNumber : item === "order" ? invoice.orderNumber : invoice.quoteNumber;
           await getClientSecret(item, invoice, number, userData ? userData.email : invoice.email, amount, 
           invoice.id, userData, teamData, paymentCardId).then(async client_secret =>{
  
            if(!client_secret){
              showNotification("Error", "There was an error. Please, try again or refresh the page.", "error");
              setOrderSubmitButton("Pay");
              setIsLoading(false);
              return;
            }
  
            paymentCardId
            ? await stripe.confirmCardPayment(client_secret, {
              payment_method: paymentCardId,
            }).then(result => handleSaveCard(result))
            : await stripe.confirmCardPayment(client_secret, {
              payment_method: {
                card: cardEelment,
                billing_details: {
                  name: cardName,
                },
              },
              setup_future_usage: "off_session",
            }).then(result => handleSaveCard(result))
          })
        }else if(selectedPaymentType === "all"){
          await stripe.confirmPayment({
            elements,
            redirect: "if_required",
            confirmParams: {
            return_url: `http://localhost:3000/account/${item}/${itemID}`
            }
          }).then(result => handleSaveCard(result))
        }
       
      } catch (e) {
        console.log(e)
        setOrderSubmitButton("Pay");
        setIsLoading(false);
        showNotification(
          "Error",
          "There was an error. Please, try again or refresh the page.",
          "error"
        );
      }finally{
        setOrderSubmitButton("Pay");
        setIsLoading(false);
      }
    };

  const handlePlaceOrder = async (quoteInfo, paypalID) => {
    setOrderSubmitButton("Placing order...");
    setIsLoading(true);

    const now = new Date();

    let orderNumber = 0;

    await getCounter("order").then((number) => {
        orderNumber = parseInt(number, 10);
      })
    .catch((error) => { });

    if (orderNumber === 0) {
      showNotification(
        "Error",
        "An error ocurred while placing the order. Please, try again. If it persists, contact support.",
        "error"
      );
      setOrderSubmitButton("Place Order");
      return false;
    }

    // const addressID = uuidv4();
    const orderID = uuidv4();

    const hardCopyAddress = quoteInfo.hardCopy && quoteInfo.hardCopyExtra;

    const address = hardCopyAddress?.newAddress
      ? {
        id: hardCopyAddress.id,
        country: hardCopyAddress.country,
        addressName: hardCopyAddress.addressName,
        firstName: hardCopyAddress.firstName,
        lastName: hardCopyAddress.lastName,
        recipient: hardCopyAddress.firstName + " " + hardCopyAddress.lastName,
        region: hardCopyAddress.region,
        city: hardCopyAddress.city,
        zipCode: hardCopyAddress.zipCode,
        street: hardCopyAddress.street,
        apartment: hardCopyAddress.apartment,
      }
      : signedIn &&
      userData &&
      userData.shipping &&
      userData.shipping.length > 0 &&
      userData.shipping.find((a) => a.id === hardCopyAddress.id);

    firestore
      .collection("orders")
      .doc(orderID)
      .set({
        orderNumber: orderNumber,
        userID: quoteInfo.userID,
        email: quoteInfo.email,
        name: quoteInfo.name,
        certified: quoteInfo.certified,
        languageFrom: quoteInfo.languageFrom,
        languageTo: quoteInfo.languageTo,
        notarization: quoteInfo.notarization,
        notarizationStatus: quoteInfo.notarization ? "pending" : null,
        expedited: quoteInfo.expedited,
        hardCopy: quoteInfo.hardCopy,
        hardCopyStatus: quoteInfo.hardCopy ? "pending" : null,
        hardCopyExtra:
          quoteInfo.hardCopy && quoteInfo.hardCopyExtra
            ? quoteInfo.hardCopyExtra
            : null,
        pagesCount: quoteInfo.certified ? quoteInfo.pagesCount : 0,
        wordCount: !quoteInfo.certified ? quoteInfo.wordCount : 0,
        notes: quoteInfo.notes,
        files: quoteInfo.files,
        timestamp: now.getTime(),
        status: "new",
        shippingInfo: hardCopyAddress ? address : null,
        paypalOrderID: paypalID,
        discountApplied: quoteInfo.discount && quoteInfo.discount > 0,
        discount:
          quoteInfo.discount && quoteInfo.discount > 0 ? quoteInfo.discount : 0,
        teamId: quoteInfo.teamId ?? "",
        totalPrice: getTotal(quoteInfo),
        expeditedServiceOption: quoteInfo.expeditedServiceOption,
        clientFirstName: quoteInfo.clientFirstName ?? "",
        clientLastName: quoteInfo.clientLastName ?? "",
        type: quoteInfo.teamId ? "business" : "personal",
        discountCode: quoteInfo.discountCode || "",
        translatorCertification: quoteInfo.translatorCertification || "",
        howDidYouHear: quoteInfo.howDidYouHear || "",
      })
      .then(async () => {
        await firestore.collection("quotes").doc(quoteInfo.id).update({
          status: "ordered",
          orderNumber: orderNumber,
          orderID: orderID,
        });

        if(quoteInfo.expedited || quoteInfo.expeditedPlus){
          decrTeamFreeExpedOrder(quoteInfo.teamId);
        }

        localStorage.setItem(
          "quote",
          JSON.stringify({ quoteID: "", name: "", email: "", parsed: true })
        );
        setOrder({ quoteID: "", name: "", email: "", parsed: true });
        

        setOrderSubmitButton("Pay");
        // setIsLoading(false);
        setShowSuccessModal(true);
      })
      .catch((error) => {
        console.log(error)
        setIsLoading(false);
        setOrderSubmitButton("Pay");
        showNotification(
          "Error",
          "An error ocurred while placing the order. Please, try again.",
          "error"
        );
      });
  };
  const handlePopUpClick = (e) => {
    setIsLoading(false);
      transitionTo(
        checkItemType(
          `/account/order/${itemID}`,
          `/account/quote/${itemID}`,
          `/account/invoice/${itemID}`,
          `/account/invoice/${itemID}`
        ),
        e
      );
      return;
  };

  const checkItemType = (
    orderItem,
    quoteItem,
    invocieItem,
    orderInvoiceItem
  ) => {
    if (item === "order") {
      return orderItem;
    }
    if (item === "quote") {
      return quoteItem;
    }
    if (item === "invoice") {
      return invocieItem;
    }
    if (item === "orderInvoice") {
      return orderInvoiceItem;
    }
  };

  const extraBreadPath =
    itemID &&
    checkItemType(
      `/account/order/${itemID}`,
      `/account/quote/${itemID}`,
      `/account/invoice/team/${itemID}`,
      `/account/invoice/order/${itemID}`
    );

  const extraBreadLinkitem =
    invoice &&
    (item === "quote" ?
        `quote # ${invoice.quoteNumber}`
      : item === "order" ?
          `order # ${invoice.orderNumber}`
      : item === "invoice" ?
          `invoice #${invoice.invoiceNumber}`
        : null);

  const buttonStyle = {
    color: "blue", // Blue color like the image
    shape: "pill", // Rounded edges
    label: "paypal", // Label "Continue with PayPal"
    tagline: false, // Hide tagline
    height: 40, // Height for larger screens
  };

  const handleDownloadInvoice = () => {
    setOpenInvoiceModal(invoice);

  };

  const handleUploadFiles = async(e) => {
    setIsLoading(true);
    const files = selectedPaymentType === "transfer" ? transferFiles : checkFiles;
    if(files.length === 0){
      setIsLoading(false);
      return showNotification(
        "Error",
        "Please, select the files to upload.",
        "error"
      );
    }
    if(item === "invoice"){
      handleInvoiceUpdate(selectedPaymentType, "on-hold", files);
    }
  }

  const PayPalBillingButtons = () => {
    return (
      <PayPalButtons
        style={buttonStyle}
        createOrder={createOrder}
        onApprove={onOrderApprove}
        onError={onOrderPaymentFailure}
        fundingSource="paypal"
      />
    );
  };
  const PayPalBillingAgreement = () => {
    const [showPayPalButtons, setShowPayPalButtons] = useState(false);
    const [{ isPending }] = usePayPalScriptReducer();

    return (
      <div>
        {!showPayPalButtons ? (
          <button
            className="bg-[#0070ba] text-white border-none rounded-[20px] px-5 py-2 text-[16px] flex items-center gap-2 cursor-pointer"
            onClick={() => setShowPayPalButtons(true)}
          >
            <PAYPALICON />
            Continue with PayPal
          </button>
        ) : (
          <div className="mt-4">
            {isPending ? <p>Loading PayPal<span className="dotsLoading">...</span></p> : <PayPalBillingButtons />}
          </div>
        )}
      </div>
    );
  };

  return (
    <>
    {openInvoiceModal && <OpenInvoiceModal type={item} order={openInvoiceModal} onClose={() => setOpenInvoiceModal(null)}/>}

      <animated.div
        style={statusOverlayProps}
        className="checkoutStatusOverlay"
      >
        We are finishing up. Please wait, this will take a second<span className="dotsLoading">...</span>
      </animated.div>

      {showSuccessModal && (
        <PopUpModal
          title={checkItemType(
            "Order Payment paid successfully",
            "Quote has been successfully paid and converted into the order",
            "Invoice Payment paid successfully",
            "Invoice Successfully Paid"
          )}
          btnText="Ok"
          onClick={(e) => handlePopUpClick(e)}
          text="You can track the status of the order on the orders page in your account"
        >
          {item === "quote" ? (
            <QUOTESUCCESS />
          ) : item === "order" ? (
            <ORDERSUCCESS />
          ) : (
            <ORDERSUCCESS />
          )}
        </PopUpModal>
      )}
      {showSendPayment && (
        <SendPaymentLinkPopUp
          data={
             invoice
          }
          type={item}
          id={itemID}
          onClose={() => setShowSendPayment(false)}
        />
      )}

      <TopBar />
      <AccountNavBar
        windowSize={windowSize}
        extraBreadLink={true}
        extraBreadPath={extraBreadPath}
        extraBreadLinkitem={extraBreadLinkitem}
        breadLinkType={checkItemType("order", "quote", "invoice", "invoice")}
        breadLink={"Choose Payment Methods"}
        selectedTab={checkItemType("orders", "quotes", "invoices", "invoices")}
        accountMainPadding={false}
        bgTransparent={true}
      >

        {!isLoading && invoice && (
          <div className="w-full flex justify-between items-center mb-4">
            <h2 className="createOrderNavbarMenuTitle">
              Choose Payment Methods
            </h2>

            <div
              onClick={() => handleDownloadInvoice()}
              className="flex flex-row items-center gap-2 bg-white border border-[#E6E7E9] rounded-md font-medium text-[#030F23] px-4 py-2 cursor-pointer"
            >
              View {item === "quote" ? "Summary" :"Invoice"}
            </div>
          </div>
        )}
        {invoice && (
          <div className="mainOrderPageContainer">
            <div className="mainOrderPageContainerOptions">
              <div id="mainPrimary" className="mainOrderPrimaryContent">
                
                <div className="quotePrimaryOptionsWrapper orderPaymentOptionWrapper">
                  <h4 className="quotePrimaryTitle">Payment Methods</h4>

                  {!isLoading && <div
                    className={`paymentMethodWrapper flex justify-start items-center gap-3`}
                  >
                   <div
                    className={`caseByCaseBtn billingPeriodBtn ${selectedPaymentType === "all" && "selectedBillingTerm"
                      }`}
                    onClick={() => {
                      setSelectedPaymentType("all");
                      setOrderSubmitButton("Pay");
                    }}
                  >
                    {/* <img
                      className="orderPaypalIcon"
                      src={STRIPEICON}
                      alt="stripe"
                    /> */}
                    <STRIPEICON className="orderPaypalIcon"/>
                  </div>
                    <div
                      className={`caseByCaseBtn billingPeriodBtn ${selectedPaymentType === "paypal" &&
                        "selectedBillingTerm"
                        }`}
                      onClick={() => setSelectedPaymentType("paypal")}
                    >
                      <img
                        className="orderPaypalIcon"
                        src={PAYPAL}
                        alt="paypal"
                      />
                    </div>
                    
                  {cardsList.length > 0 && <div
                    className={`caseByCaseBtn billingPeriodBtn ${selectedPaymentType === "card" && "selectedBillingTerm"
                      }`}
                    onClick={() => {
                      setSelectedPaymentType("card");
                      setOrderSubmitButton("Pay");
                    }}
                  >
                    <img
                      className="orderPaypalIcon"
                      src={CARDICON}
                      alt="card"
                    />
                    Saved Cards
                  </div>}
                  {item === "order" && invoice.status === "created" && invoice.type === "business" && <div
                      className={`caseByCaseBtn billingPeriodBtn ${selectedPaymentType === "pay-later" &&
                        "selectedBillingTerm"
                        }`}
                      onClick={() => {
                        setSelectedPaymentType("pay-later");
                        setOrderSubmitButton("Pay Later");
                      }}
                    >
                      <img
                        className="orderPaypalIcon"
                        src={CARDICON}
                        alt="card"
                      />
                      Pay Later
                    </div>}
                    {item=== "invoice" && invoice.teamId && (
                      <div
                        className={`caseByCaseBtn billingPeriodBtn ${selectedPaymentType === "transfer" &&
                          "selectedBillingTerm"
                          }`}
                        onClick={() => setSelectedPaymentType("transfer")}
                      >
                        <BANK />
                        Transfer
                      </div>
                    )}
                    {item=== "invoice" && invoice.teamId && (
                      <div
                        className={`caseByCaseBtn billingPeriodBtn ${selectedPaymentType === "check" &&
                          "selectedBillingTerm"
                          }`}
                        onClick={() => setSelectedPaymentType("check")}
                      >
                        <CHECK />
                        Check
                      </div>
                    )}
                  </div>}

                  {selectedPaymentType === "all" && !showSuccessModal && invoice && (
                    <StripeExpressCheckout type={item} amount={item === "invoice" ? invoice.totalPrice : (getTotal(invoice) - getDiscount(invoice))}  item={invoice}
                    id={invoice.id} discount={discount} onStripeReady={handleStripeReady} setSaveCard={setSaveCard} saveCard={saveCard}
                    number={item === "invoice" ? invoice.invoiceNumber : item === "order" ? invoice.orderNumber : invoice.quoteNumber}/>
                  )}

                  {selectedPaymentType === "card" && (
                    <div className="px-5 pb-5 w-full space-y-4">
                      <ElementsWrapper>
                        <Billing
                          setSelectedCard={setPaymentCardId}
                          selectedCard={paymentCardId}
                          setCardOwner={setCardName}
                          cardOwner={cardName}
                          saveCard={saveCard}
                          setSaveCard={setSaveCard}
                          cardsList={cardsList}
                          setCardsList={setCardsList}
                          showNewCard={false}
                          onStripeReady={handleStripeReady}
                          />
                      </ElementsWrapper>
                    </div>
                  )}

                  {item === "order" && invoice.status === "created" && selectedPaymentType === "pay-later" && (
                    <div className="grid gap-4 text-start p-3 w-full">
                      {signedIn ?
                      <p className="mainSecureAndPrivateText">
                        To proceed with the Pay-Later option, simply select "Pay" button. <br/>
                        Your order will be placed immediately, and you'll be able to complete your payment later.
                      </p> :
                      <p className="mainSecureAndPrivateText">
                        To access the Pay-Later option, you need to create a business account. <br/><br/>
                        With Pay-Later option, Your order will be placed immediately and you'll be able to complete your payment later.
                      </p>
                      }
                    </div>
                  )}

                  {selectedPaymentType === "paypal" && (
                    <div className="grid gap-4 text-start px-5 pb-5 w-full">
                      <p className="text-[#686F7B] max-w-screen-sm font-normal">
                        To proceed with your payment, please click on the
                        "PayPal" button. A PayPal page will open where you can
                        securely complete your transaction. Please follow the
                        instructions on the PayPal page to finalize your
                        payment.
                      </p>

                      {/* <PayPalBilling userData={userData} saveAccount={false} chargeAccount={true} afterOrderApprove={onAfterOrderApprove}/> */}
                      {/* <PayPalBilling userData={userData} */}


                      {/* <h3 className="text-[#030F23] font-semibold text-lg font-secondary">
                        Connect to PayPal
                      </h3>

                      <p className="text-[#686F7B] max-w-screen-sm font-normal">
                        Connecting to PayPal will simplify and speed up future
                        payment processes by eliminating the need to re-enter
                        payment information with every purchase.
                      </p>
                      {((item === "invoice" && invoice.totalPrice !== 0) || getTotal(invoice) !== 0) &&
                        <PayPalBillingAgreement />
                      } */}

                    </div>
                  )}

                  {selectedPaymentType === "transfer" && (
                    <BankTransfer windowSize={windowSize} files={transferFiles} setFiles={setTransferFiles} />
                  )}

                  {selectedPaymentType === "check" && (
                    <CheckTransfer windowSize={windowSize} files={checkFiles} setFiles={setCheckFiles} />
                  )}

                  
                </div>

                {/* <animated.div
        style={discountOverlayProps}
        className="checkoutStatusOverlay"
      >
        Applying Discount, Please wait...
      </animated.div> */}

                {item === "order" && invoice.status === "created" &&  <div className="quotePrimaryOptionsWrapper">
                <h4 className="quotePrimaryTitle">Discount Code</h4>
                <div className="orderDiscountCodeWrapper">
                  <FormTextInput
                    placeholder={"Discount code"}
                    value={discountCode}
                    onChange={setDiscountCode}
                    discountIcon={discount > 0}
                    discountIconText={`${discount}%`}
                  />
                  <NewButton
                    text={"Apply"}
                    back={true}
                    icon={false}
                    // onClick={() => handleApplyCode()}
                    whiteBtn={true}
                  />
                </div>
              </div>}
              </div>
              {/* {item !== "invoice" && (item === "order" ? invoice.status === "created" : true) && <div className="quotePrimaryOptionsWrapper">
                    <h4 className="quotePrimaryTitle">Discount Code</h4>
                    <div className="orderDiscountCodeWrapper">
                      <FormTextInput
                        placeholder={"Discount code"}
                        value={discountCode}
                        onChange={setDiscountCode}
                        discountIcon={discount > 0}
                        discountIconText={`${discount}%`}
                      />
                      <NewButton
                        text={"Apply"}
                        back={true}
                        icon={false}
                        // onClick={() => handleApplyCode()}
                        whiteBtn={true}
                      />
                    </div>
                  </div>} */}
            </div>

            {item !== "invoice" ? <div className="mainOrderSecondaryContent">
              <div className="mainOrderSecondaryContentWrap">
                <OrderSummary
                  paypalBtn={selectedPaymentType === "paypal" && (getTotal(invoice)- getDiscount(invoice)) > 0}
                  order={invoice}
                  certified={invoice.certified}
                  pagesCount={invoice.pagesCount}
                  languageFrom={invoice.languageFrom}
                  languageTo={invoice.languageTo}
                  discount={invoice.discount}
                  showBtn={((selectedPaymentType === "card" || selectedPaymentType === "all") && (getTotal(invoice)- getDiscount(invoice)) >= 1) ||
                    (item === "order" && invoice.status === "created" && invoice.type === "business" && selectedPaymentType === "pay-later")}
                  handleBtnSubmit={(e) =>handleCardSubmit(e)}
                  btnText={orderSubmitButton}
                  disableBtn={isLoading ||(invoice.status === "pay-later" || invoice.status === "overdue")}
                  sendPaymentLinkBtn={true}
                  onClickPaymentLink={() => {
                    setShowSendPayment(true);
                  }}
                  createOrder={createOrder}
                  onApprove={onOrderApprove}
                  onError={onOrderPaymentFailure}
                  windowSize={windowSize}
                  totalWarning={((selectedPaymentType === "card" || selectedPaymentType === "all") && (getTotal(invoice)- getDiscount(invoice)) < 1) 
                    || (selectedPaymentType === "paypal" && (getTotal(invoice)- getDiscount(invoice)) <= 0)}
                />

                {item !== "orderInvoice" && (
                  <div>
                    <SecureAndPrivate />
                  </div>
                )}
              </div>
            </div> :
            invoice && <div className="mainOrderSecondaryContent">
                          <div className="mainOrderSecondaryContentWrap">
                            <div className="orderSummary">
                              <h2 className="orderSummaryTitle">SUMMARY</h2>
                              <div className="orderSummaryInfoWrapper">
                                <div className="orderSummaryInfo">
                                  <h4 className="orderSummaryInfoType">Orders</h4>
                                </div>
                                <div className={`invoiceOrdersScroll ${invoice.type === "multipleInvoice" && orders.length > 1 ? "pr-[0.75rem]" : ""}`} >
                                { orders.length > 0 && orders.map(order => (
                                  <>
                                <div key={order.id} className="orderSummaryInfo cursor-pointer" onClick={() => setIsOrderSummaryOpen(!isOrderSummaryOpen)}>
                                  <p className="orderSummaryInfoCount">
                                    {getShortOrderNo(order.orderNumber)}
                                  </p>
                                  <p className="orderSummaryInfoCount">
                                    <div className="flex items-center gap-1">
                                      {formatTotal(getTotal(order) - getDiscount(order))}
                                      {invoice.type === "multipleInvoice" && orders.length > 1 ? isOrderSummaryOpen ? <ChevronUp size={20} onClick={() => setIsOrderSummaryOpen(false)} /> : <ChevronDown size={20} onClick={() => setIsOrderSummaryOpen(true)}/>  : ""}
                                    </div>
                                  </p>

                                </div>
                                <OrderSummary
                                    paypalBtn={false}
                                    order={order}
                                    certified={order.certified}
                                    pagesCount={order.pagesCount}
                                    languageFrom={order.languageFrom}
                                    languageTo={order.languageTo}
                                    discount={order.discount}
                                    showBtn={false}
                                    sendPaymentLinkBtn={false}
                                    windowSize={windowSize}
                                    invoiceOrderSummary={true}
                                    openModal={invoice.type === "multipleInvoice" && orders.length > 1 ? isOrderSummaryOpen : true}
                                    setOpenModal={setIsOrderSummaryOpen}
                                    showTotal={invoice.type === "multipleInvoice" && orders.length > 1}
                                  />
                                </>
                                ))}
                                
                                </div>
                              </div>
            
                                <div className="orderSummaryTotal">
                                  <h4>Total</h4>
                                  <h4>
                                    {formatTotal(invoice.totalPrice)}
                                  </h4>
                                </div>

                                {(((selectedPaymentType === "card" || selectedPaymentType === "all") && (item === "invoice" && invoice.totalPrice < 1) )|| 
                                (selectedPaymentType === "paypal" && (item === "invoice" && invoice.totalPrice <= 0)))
                                 && <div className="orderSummaryTotal">
                                  <h4 style={{color: "#FF0000"}}>Item total must be greater than $1</h4>
                                </div>}
                               
                              {(invoice.status === "pay-later" || invoice.status === "overdue") && (
                                <div className="w-full mt-4">
                                  {selectedPaymentType === "paypal" && (item === "invoice" && invoice.totalPrice > 0) ? 
                                   <PayPalButtons style={{ layout: "vertical", height: windowSize.width > 1024 ? 40 : 35, width: "100%" }} 
                                   className='w-full' createOrder={() => createOrder} onApprove={onOrderApprove} onError={onOrderPaymentFailure} />
                                  : 
                                  <NewButton
                                    width="100%"
                                    disabled={selectedPaymentType === "transfer" ? transferFiles.length === 0 : selectedPaymentType === "check" ? checkFiles.length === 0 
                                      : (selectedPaymentType === "card" || selectedPaymentType === "all") ? (item === "invoice" && invoice.totalPrice < 1) : false}
                                    onClick={(e) => selectedPaymentType === "transfer" || selectedPaymentType === "check" ? handleUploadFiles(e) : handleCardSubmit(e)}
                                    text={"Pay"}
                                  />}
                                  <div className="w-full mt-2">
                                   <NewButton width="100%" text={"Send Payment Link"} onClick={() => setShowSendPayment(true)} disable={false} back={true} icon={false} whiteBtn sendIcon />
                                  </div>
                                </div>
                              )}
                            </div>
                          </div>
                        </div>
                        }
          </div>
        )}
      </AccountNavBar>
    </>
  );
};

export default MakePayment;
